export default __webpack_public_path__ + "static/media/005-fountain-pen.537d704e.png";